import styled from 'styled-components';

export const AwardsSection = styled.div`
  flex-basis: 30%;
  @media (min-width: 768px) {
    padding-left: 5%;
  }
`;
export const AwardsContainer = styled.div`
  display: flex;

  justify-content: space-between;
  padding-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 30px;
    align-items: center;
  }
`;
export const PrTitle = styled.h3`
  text-align: center;
  letter-spacing: 4.6px;
  font-size: clamp(14px, 2vw, 18px);
  font-weight: 600;
  opacity: 0.7;
  &::after {
    width: ${(props) => (!props.award ? '120px' : '234px')};
    height: 3px;
    margin: ${(props) => (!props.award ? '10px 310px 0' : '10px 110px 0')};

    @media (min-width: 1600px) {
      margin: ${(props) => (!props.award ? '10px 355px 0' : '10px 110px 0')};
    }
    @media (max-width: 1400px) {
      margin: ${(props) => (!props.award ? '10px 270px 0' : '10px 110px 0')};
    }
    @media (max-width: 768px) {
      margin: ${(props) => (!props.award ? '10px auto 0' : '10px auto 0')};
    }
    opacity: 0.09;
    background-color: #000;
    display: block;
    content: '';
  }
`;
export const AwardCard = styled.div`
  text-align: center;
  p {
    font-size: 14px;
    color: #050d3a;
    opacity: 0.87;
    max-width: 205px;

    margin-top: 16px;
  }
`;
export const AwardImg = styled.div``;
